import { JSX, ReactNode } from 'react';
import { LoggingContext } from 'vopay';
import { useDatadogLog } from '@/hooks/useDatadogLog';

// this is used to provide logging functionality to components
export const LoggingProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const { datadogLog } = useDatadogLog();

  return <LoggingContext.Provider value={datadogLog}>{children}</LoggingContext.Provider>;
};
